import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SourceOfWealthTypesModel } from '../../Models/Models/Payments/SourceOfWealthTypesModel';

declare var IS_RUNNING_IN_APP_POOL;

export class SourceOfWealthTypesClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(): Promise<SourceOfWealthTypesModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Payments/SourceOfWealthTypes/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<SourceOfWealthTypesModel, any>(url, data);
  }
}

